import { CadastreHousingValueConveyance as ACHVC } from '../realty/model/CadastreHousingValueConveyance';
import { ApiDate } from '../realty/model/ApiDate';
import { evaluate } from '../utility/Control';

export class CadastreHousingValueConveyance {
  public purchasePrice: number;
  public dateRegistered: ApiDate;
  public unitType: string;

  public constructor(apiCadastreHousingValueConveyance: ACHVC) {
    this.purchasePrice = apiCadastreHousingValueConveyance.purchasePrice;
    this.dateRegistered = apiCadastreHousingValueConveyance.dateRegistered;
    this.unitType = evaluate(apiCadastreHousingValueConveyance, 'dwellingType.text');
  }
}



/** WEBPACK FOOTER **
 ** ./src/model/CadastreHousingValueConveyance.ts
 **/